import React from "react";
import LegalPageLayout from "@/legal/LegalPageLayout";
import { OPERATOR, BRAND } from "@/legal/legalConfig";

export default function Imprint() {
  return (
    <LegalPageLayout title="Impressum" lastUpdated="08.02.2026" testid="imprint-page">
      <h2>Angaben gemäß § 5 TMG</h2>
      <p data-testid="imprint-operator-block">
        <strong>{OPERATOR.legal_name}</strong><br />
        {OPERATOR.street}<br />
        {OPERATOR.zip} {OPERATOR.city}<br />
        {OPERATOR.country}
      </p>

      <h2>Kontakt</h2>
      <p>
        E-Mail: <a href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a>
      </p>

      <h2>Umsatzsteuer-Identifikationsnummer</h2>
      <p data-testid="imprint-vat-id">
        USt-ID gemäß § 27a Umsatzsteuergesetz: <strong>{OPERATOR.vat_id}</strong>
      </p>

      <h2>Vertretungsberechtigt</h2>
      <p>Andreas Kosmatos</p>

      <h2>Verantwortlich für den Inhalt gemäß § 18 Abs. 2 MStV</h2>
      <p>
        Andreas Kosmatos<br />
        {OPERATOR.street}, {OPERATOR.zip} {OPERATOR.city}
      </p>

      <h2>EU-Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">https://ec.europa.eu/consumers/odr/</a>.
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <h2>Haftung für Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf {BRAND.name} nach den allgemeinen Gesetzen verantwortlich.
        Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
      </p>

      <h2>Haftung für Links</h2>
      <p>
        {BRAND.name} enthält gegebenenfalls Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben.
        Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
      </p>

      <h2>Urheberrecht</h2>
      <p>
        Die durch den Betreiber erstellten Inhalte und Werke auf {BRAND.name} unterliegen dem deutschen Urheberrecht.
        Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
      </p>
    </LegalPageLayout>
  );
}
